var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivingroom4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.74 264.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#6a6a84;}.c{fill:#fff;}.d{fill:#fff8a5;}.e{fill:#ffc8bf;}.f{fill:#e79d96;}.g{fill:#ff828a;}.h{fill:#805159;}.i{fill:#94646c;}.j{fill:#303061;}.k{fill:#ddfdff;}.l{fill:#438300;}.m{fill:#70cee7;}.n{fill:#2c2d36;}.o{fill:#335b00;}.p{fill:#552c00;}.q{fill:#77daed;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M15.17,47.37h30.61s.86,13.77-15.31,13.77c-15.31,0-15.31-13.77-15.31-13.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M46.07,47.58H14.88l.09-.28L30.48,0l.2,.61,15.39,46.97Zm-30.61-.42h30.03L30.48,1.35,15.46,47.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 30.27,
    y: 0.68,
    width: 0.42,
    height: 60.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M30.47,61.36c-.16-.05-11.38-3.42-12.89-13.96l.42-.06c1.42,9.9,11.69,13.33,12.49,13.58,9.2-1.98,11.38-13.47,11.4-13.59l.41,.08c-.02,.12-2.26,11.93-11.78,13.94h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M30.43,61.37l-.08-.05c-7-4.83-7.78-13.83-7.79-13.92l.42-.03c0,.09,.77,8.82,7.52,13.55,.68-.24,5.17-2.27,7.04-13.57l.42,.07c-2.07,12.49-7.22,13.88-7.44,13.94l-.09,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "34.92 72.27 30.5 61.74 27.03 72.26 26.63 72.12 30.45 60.54 35.31 72.11 34.92 72.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "32.46 71.39 30.6 62.73 30.15 71.35 29.72 71.33 30.35 59.55 32.87 71.3 32.46 71.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M13.69,74.18l-.4-.12s1.17-3.96-.91-7.04c-2.25-3.32-2.77-5.75-2.06-9.65,.62-3.41,1.87-6.14,3.81-8.33,.36-.4,.81-.98,1.33-1.66,1.91-2.45,4.51-5.81,6.81-6.27,.9-.17,1.73,.06,2.51,.71,1.55,1.28,2.34,3.98,2.33,5.33h-.42c.02-1.28-.73-3.81-2.18-5.01-.67-.56-1.4-.77-2.15-.61-2.15,.42-4.8,3.85-6.56,6.11-.53,.68-.98,1.27-1.35,1.68-1.89,2.14-3.11,4.79-3.71,8.13-.69,3.77-.18,6.12,1.99,9.33,2.2,3.25,1.01,7.23,.96,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M25.59,83.25c-.02-.06-1.48-5.88-4.65-9.85-2.09-2.62-2.29-6.17-2.44-8.76-.08-1.4-.15-2.6-.51-3.07-.13-.18-.29-.37-.45-.57-1.22-1.51-3.07-3.79-2.16-6.29,1-2.74,4.41-10.36,7.22-10.36,.07,0,.14,0,.21,.01,1,.14,1.73,.51,2.17,1.09,.52,.69,.34,1.13,.43,1.7h-.46c-.05,.37,.23-2.03-2.2-2.37-.05,0-.11-.01-.16-.01-2.35,0-5.65,6.87-6.82,10.08-.82,2.27,.93,4.44,2.1,5.88,.17,.21,.33,.4,.46,.58,.44,.57,.5,1.78,.59,3.3,.15,2.53,.35,6,2.35,8.52,3.22,4.04,4.71,9.95,4.72,10.01l-.41,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M23.05,60.2c-.14-1.58-.45-4.51-.72-7.1-.21-2.05-.41-3.95-.5-4.96-.08-.79,.08-1.32,.46-1.55,.59-.37,1.86,.56,1.89,.58h-.61c-.19-.11-.75-.42-1.06-.22-.23,.14-.32,.54-.26,1.16,.09,1.01,.29,2.9,.5,4.95,.27,2.59,.57,5.53,.71,7.11l-.42,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M28.06,51.56h-.42c.04-2.02,.24-6.71,1.18-6.93,.19-.04,.38,0,.53,.12,.58,.47,.59,2.23,.58,2.42h-.42c.01-.63-.11-1.83-.43-2.09-.05-.04-.1-.05-.17-.04-.39,.14-.79,3.13-.86,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M37.61,47.16c-.18-.8-.31-2.53-1.91-3.13-.52-.2-.92-.21-1.15-.05-.26,.19-.26,.58-.26,.58h-.42s-.02-.6,.43-.92c.36-.25,.88-.25,1.55,0,1.85,.69,2.21,3.42,2.22,3.52h-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M31.51,64.16l-.42-.07c.06-.39,1.53-9.71,3.27-13.45,.45-.96,.78-1.79,1.05-2.45,.78-1.92,1.15-2.83,2.52-2.83,.05,0,.11,0,.17,0,.68,.04,1.15,.25,1.41,.62,.35,.51,.16,1.15,.15,1.18h-.45s.18-.6-.06-.94c-.18-.26-.54-.41-1.08-.44-.05,0-.1,0-.15,0-1.04,0-1.34,.62-2.12,2.57-.27,.67-.61,1.5-1.06,2.47-1.71,3.68-3.22,13.24-3.23,13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M39.82,80.31c-.08-.23,0-1.27,.25-4.21,.2-2.31,.44-5.18,.52-7.31,.08-2.18-.39-4.67-.8-6.87-.36-1.94-.68-3.61-.5-4.55,.55-2.79,1.71-10.41,.55-12.06-.11-.16-.23-.25-.38-.27-2.08-.33-3.31,.35-4.31,2.12h-.48c1.08-1.91,2.62-2.9,4.85-2.53,.26,.04,.48,.19,.66,.44,1.49,2.14-.4,11.97-.49,12.39-.17,.85,.14,2.49,.5,4.39,.42,2.22,.89,4.74,.81,6.96-.08,2.14-.33,5.02-.52,7.33-.16,1.88-.33,3.82-.27,4.05l-.4,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M49.52,71.74s-2.26-6.41-3.72-10.53c-1.27-3.58-2.1-8.07-2.77-11.68-.1-.55-.2-1.08-.3-1.57-.1-.51-.19-1.01-.27-1.49-.53-2.91-.95-5.22-2.12-5.9-.26-.15-.38-.06-.46,.05-.52,.68-.09,4.2,2.29,6.54h-.44c-2.36-2.33-2.96-5.78-2.18-6.8,.24-.32,.62-.38,1.01-.16,1.34,.78,1.78,3.17,2.32,6.19,.09,.48,.18,.97,.27,1.48,.09,.5,.19,1.03,.3,1.58,.67,3.59,1.5,8.06,2.76,11.62,1.46,4.12,3.72,10.53,3.72,10.53l-.4,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M53.02,66.29c-.02-.08-1.83-7.97-4.61-12.76-1.49-2.56-1.89-4.25-2.18-5.48-.27-1.12-.45-1.87-1.27-2.61-.37-.33-.68-.46-.86-.38-.39,.19-.47,1.59-.44,2.11h-.42c-.01-.19-.07-2.13,.68-2.49,.36-.17,.8-.02,1.32,.45,.93,.83,1.13,1.67,1.4,2.83,.29,1.21,.68,2.86,2.14,5.37,2.82,4.85,4.64,12.8,4.66,12.88l-.41,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M8.18,64.46s5.32-2.29,1.73-3.88c-1.94-.87-1.73,3.88-1.73,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M18.02,66.91s4.17-5.42-.45-5.01c-2.5,.23,.45,5.01,.45,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M31.39,67.46s4.17-5.42-.45-5.01c-2.5,.23,.45,5.01,.45,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M9.7,52.88s6.84,.25,3.82-3.27c-1.64-1.91-3.82,3.27-3.82,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M17.45,44.3s6.84,.25,3.82-3.27c-1.64-1.91-3.82,3.27-3.82,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M50.64,57.16s.86-6.79-2.92-4.09c-2.05,1.46,2.92,4.09,2.92,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M47.85,49.93s.86-6.79-2.92-4.1c-2.05,1.46,2.92,4.1,2.92,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M14.71,59.03s3.18-3.02,.21-3.22c-1.61-.11-.21,3.22-.21,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M27.39,53.96s3.18-3.02,.21-3.22c-1.61-.11-.21,3.22-.21,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M39.33,59.87s3.18-3.02,.21-3.22c-1.61-.11-.21,3.22-.21,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M50.37,73.7s.91-4.29-1.65-2.77c-1.38,.82,1.65,2.77,1.65,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M22.81,53.2s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M26.03,46.42s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M43.94,53.96s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M41.3,44.84s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M23.75,63.25s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M21.59,76.41s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M41.3,71.93s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M39.94,82.92s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M32.44,55.08s5.07-2.76,1.37-4.01c-2.01-.68-1.37,4.01-1.37,4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M32.44,47.92s5.07-2.76,1.37-4.01c-2.01-.68-1.37,4.01-1.37,4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M46.68,64.95s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M53.72,68.35s2.59-5.16-1.17-4.08c-2.04,.59,1.17,4.08,1.17,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M11.12,69.19s4-2,1.17-3.08c-1.54-.58-1.17,3.08-1.17,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M12.42,76.41s4.01-2,1.17-3.08c-1.54-.58-1.17,3.08-1.17,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M26.68,85.33s1.49-4.22-1.3-3.02c-1.51,.65,1.3,3.02,1.3,3.02Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M175.31,56.62c-.46-3.64-4.46-22.52-38.03-22.52s-37.19,18.89-37.51,22.52l-.03,70.06h75.63l-.06-70.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M177.09,128.4H98.02l.03-71.77c.36-4.17,3.89-24.24,39.23-24.24s39.23,20.01,39.74,24.03v.21l.07,71.78Zm-75.63-3.44h72.2l-.06-68.23c-.5-3.74-4.56-20.92-36.31-20.92s-35.49,17.46-35.8,20.96l-.03,68.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M122.66,56.62s1.45-10.97,14.62-10.97,13.91,10.97,13.91,10.97h-28.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M124.04,56.81l-2.76-.37c.02-.12,1.78-12.18,16-12.18s15.29,12.12,15.3,12.24l-2.78,.25c-.04-.39-1.06-9.7-12.53-9.7s-13.18,9.36-13.23,9.76Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 99.74,
    y: 90.63,
    width: 75.19,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 121.27,
    y: 56.62,
    width: 2.79,
    height: 70.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 149.8,
    y: 56.62,
    width: 2.79,
    height: 70.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 99.77,
    y: 55.23,
    width: 75.54,
    height: 2.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M111.84,39.52l15.45,9.26-15.45-9.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 118.17,
    y: 35.14,
    width: 2.78,
    height: 18.01,
    transform: "translate(20.24 124.01) rotate(-59.07)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M162.41,39.52l-15.45,9.26,15.45-9.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 145.68,
    y: 42.76,
    width: 18.01,
    height: 2.78,
    transform: "translate(-.7 85.75) rotate(-30.92)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.89,
    y: 34.1,
    width: 2.79,
    height: 11.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 69.46,
    y: 23.89,
    width: 138.44,
    height: 3.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M72.77,23.89s-3.27,36.64-2.48,64.88c.79,28.24-1.72,82.28-12.22,97.85,0,0,11.88,2.12,23.84,.89,11.97-1.23,29.87,0,29.87,0,0,0,5.04-38.59,2.51-77.8-2.53-39.21,2.02-85.82,2.02-85.82h-43.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M75.42,169.63l-1.09-.31c4.06-14.13,6.65-52.7,4.95-73.71-1.66-20.41,2.03-63.74,2.06-64.17l1.13,.1c-.04,.44-3.71,43.66-2.06,63.98,1.71,21.1-.9,59.89-4.99,74.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M96.73,178l-1.1-.27c3.52-14.28,4.62-52.92,2.11-73.84-2.44-20.33-.43-63.76-.41-64.2l1.13,.05c-.02,.43-2.03,43.77,.4,64.01,2.52,21.02,1.41,59.88-2.13,74.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M202.97,23.89s3.27,36.64,2.48,64.88c-.79,28.24,1.72,82.28,12.22,97.85,0,0-11.88,2.12-23.84,.89-11.97-1.23-29.87,0-29.87,0,0,0-5.04-38.59-2.51-77.8,2.53-39.21-2.02-85.82-2.02-85.82h43.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M200.31,169.63c-4.09-14.22-6.7-53.01-4.99-74.11,1.65-20.32-2.02-63.55-2.06-63.98l1.13-.1c.04,.43,3.72,43.76,2.06,64.17-1.7,21,.89,59.58,4.95,73.71l-1.09,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M179.01,178c-3.54-14.37-4.65-53.23-2.13-74.25,2.43-20.24,.42-63.58,.4-64.01l1.13-.05c.02,.44,2.03,43.87-.41,64.2-2.51,20.92-1.41,59.56,2.11,73.84l-1.1,.27Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 67.3,
    cy: 25.88,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 210.06,
    cy: 25.88,
    r: 2.98
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M255.29,55.15l-9.62-15.82-8.32,15.8-.78-.41,8.68-16.49c.07-.14,.22-.23,.38-.23,.13-.03,.31,.08,.39,.21l10.03,16.49-.75,.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 230.42,
    y: 51.72,
    width: 30.43,
    height: 26.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M261.73,79.55h-32.2v-28.72h32.2v28.72Zm-30.43-1.76h28.67v-25.19h-28.67v25.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M261.73,79.55h-32.2v-28.72h32.2v28.72Zm-30.43-1.76h28.67v-25.19h-28.67v25.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 243.86,
    y: 67.33,
    width: 3.27,
    height: 9.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M244.98,55.99s-5.88,5.66-4.9,6.59c.98,.93,3.54,.7,1.14,2.81-2.4,2.11-2.46,3.51-1.16,3.97,1.31,.47,2.19,.03,.23,1.67-1.96,1.63-2.36,3.23-.83,3.45,1.53,.22,12.62,.76,12.93-.51,.6-2.45-3.59-2.91-2.45-3.6,1.09-.65,1.72-.93,1.69-2.12-.05-1.63-5.99-4.03-2.51-5.25,2.57-.9-1.31-4.94-4.14-7.01Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 226.6,
    y: 113.23,
    width: 38.07,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 228.72,
    y: 95.72,
    width: 3.36,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 232.08,
    y: 95.72,
    width: 3.36,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    x: 252.71,
    y: 102.73,
    width: 3.36,
    height: 17.5,
    transform: "translate(142.9 365.87) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 251.7,
    y: 100.15,
    width: 1.68,
    height: 17.5,
    transform: "translate(143.64 361.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 237.79,
    y: 95.59,
    width: 3.36,
    height: 17.5,
    transform: "translate(-18.99 66.48) rotate(-15.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 226.6,
    y: 104.17,
    width: 1.36,
    height: 10.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 263.31,
    y: 104.17,
    width: 1.36,
    height: 10.66
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingroom4);
export default __webpack_public_path__ + "static/media/livingroom-4.e8ad8838c0fba0fa1b159a93ead41cf4.svg";
export { ForwardRef as ReactComponent };